import React from "react";
import { Form, Row, Divider, Typography, Input, InputNumber, Button, Space, Table, Select, DatePicker } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { c_FormaPago } from "../../../SATCatalogos/index";
import TotalesComplementoPagoSection from "./TotalesComplementoPagoSection";
import Decimal from "decimal.js";
import { calcularImpuestosPComplementoPago, cambiarEquivalenciaDR } from "../services";

const { Title } = Typography;
const { Option } = Select;

const ComplementosPagoSection = ({transaccionObj}) => {
    const form = Form.useFormInstance();


    //Al cambiar el monto del pago, se recalculan los totales del complemento de pago
    const handleMontoChange = () => {
        calcularImpuestosPComplementoPago(form);
    };

    //Al cambiar la base del impuesto del documento relacionado, 
    //se recalculan los impuestos del pago y por ende el total de impuestos trasladados en el complemento de pago
    const handleOnChangeBaseDR = (value, record) => {
        const basePath = ["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "DoctoRelacionado", record.name];
        const tasaOCuota = form.getFieldValue([...basePath, "ImpuestosDR", "TrasladosDR", 0, "TasaOCuotaDR"]) || "0";
        const importeDR = new Decimal(value || 0).mul(new Decimal(tasaOCuota)).toDecimalPlaces(2, Decimal.ROUND_DOWN);
        form.setFieldValue([...basePath, "ImpuestosDR", "TrasladosDR", 0, "ImporteDR"], importeDR);
        calcularImpuestosPComplementoPago(form);
    };

    //Al cambiar la tasa del impuesto del documento relacionado, 
    //se recalculan los impuestos del pago y por ende el total de impuestos trasladados en el complemento de pago
    const handleOnChangeTasaOCuotaDR = (value, record) => {
        const basePath = ["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "DoctoRelacionado", record.name];
        const baseDR = form.getFieldValue([...basePath, "ImpuestosDR", "TrasladosDR", 0, "BaseDR"]) || "0";
        const importeDR = new Decimal(baseDR).mul(new Decimal(value)).toDecimalPlaces(2, Decimal.ROUND_DOWN);
        form.setFieldValue([...basePath, "ImpuestosDR", "TrasladosDR", 0, "ImporteDR"], importeDR);
        calcularImpuestosPComplementoPago(form);
    };

    //Al cambiar la moneda del pago, se actualiza el tipo de cambio y el monto dependiendo si es peso o dólar, además de recalcular los impuestos del pago
    const handleSeleactMonedaP = (value) => {

        const path = ["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0];
        let tipo_cambio = transaccionObj?.tipo_cambio || 1;
        let monto_dolar = transaccionObj?.monto_dolar || 0;
        if(value === "USD"){
            form.setFieldValue([...path, "TipoCambioP"], tipo_cambio);
            form.setFieldValue([...path, "Monto"],monto_dolar);
        }else{
            form.setFieldValue([...path, "TipoCambioP"], 1);
            form.setFieldValue([...path, "Monto"], transaccionObj?.monto || 0);
        }

        cambiarEquivalenciaDR(form, tipo_cambio, value);

        calcularImpuestosPComplementoPago(form);
    }

    const pagoColumns = [
        {
            title: "FechaPago",
            key: "FechaPago",
            width: 140,
            render: () => (
                <>
                    <Form.Item
                        name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "FechaPago"]}
                        noStyle
                        rules={[{ required: true, message: "Ingrese FechaPago" }]}
                    >
                        <DatePicker 
                            showTime
                            bordered={false}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item
                        name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "NumOperacion"]}
                        noStyle
                    >
                        <Input type="hidden" />
                    </Form.Item>
                </>
            ),
        },
        {
            title: "FormaDePagoP",
            key: "FormaDePagoP",
            width: 150,
            render: () => (
                <Form.Item
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "FormaDePagoP"]}
                    noStyle
                    rules={[{ required: true, message: "Ingrese FormaDePagoP" }]}
                >
                    <Select bordered={false} size="small" style={{ width: "100%" }}>
                        {c_FormaPago.map(({ forma_pago, descripcion }) => (
                            <Option key={forma_pago} value={forma_pago}>
                                <strong>{forma_pago}</strong> - {descripcion}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: "MonedaP",
            key: "MonedaP",
            width: 80,
            render: () => (
                <Form.Item
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "MonedaP"]}
                    noStyle
                    rules={[{ required: true, message: "Ingrese MonedaP" }]}
                >
                    <Select bordered={false} size="small" style={{ width: "100%" }} onSelect={handleSeleactMonedaP}>
                        <Option key={"MXN"} value={"MXN"}>
                            <strong>MXN</strong> - Peso Mexicano
                        </Option>
                        <Option key={"USD"} value={"USD"}>
                            <strong>USD</strong> - Dólar Estadounidense
                        </Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: "Monto",
            key: "Monto",
            width: 100,
            render: () => (
                <Form.Item
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "Monto"]}
                    noStyle
                    rules={[{ required: true, message: "Ingrese Monto" }]}
                >
                    <InputNumber
                        style={{ textAlign: "end", width: "100%" }}
                        controls={false}
                        formatter={(value) => {
                            if (!value) return "";
                            const parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return `$ ${parts.join(".")}`;
                        }}
                        parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                        bordered={false}
                        onChange={handleMontoChange}
                    />
                </Form.Item>
            ),
        },
        {
            title: "TipoCambioP",
            key: "TipoCambioP",
            width: 100,
            render: () => (
                <Form.Item
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "TipoCambioP"]}
                    noStyle
                >
                    <Input bordered={false} />
                </Form.Item>
            ),
        },
    ];

    const doctoColumns = (remove) => [
        {
            title: "Documento",
            key: "Documento",
            width: 300,
            render: (_, record) => (
                <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                        const basePath = ["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "DoctoRelacionado", record.name];
                        const idDocumento = getFieldValue([...basePath, "IdDocumento"]) || "";
                        const serie = getFieldValue([...basePath, "Serie"]) || "";
                        const folio = getFieldValue([...basePath, "Folio"]) || "";
                        const monedaDR = getFieldValue([...basePath, "MonedaDR"]) || "";

                        return (
                            <>
                                <Form.Item name={[record.name, "IdDocumento"]} noStyle>
                                    <input type="hidden" />
                                </Form.Item>
                                <Form.Item name={[record.name, "Serie"]} noStyle>
                                    <input type="hidden" />
                                </Form.Item>
                                <Form.Item name={[record.name, "Folio"]} noStyle>
                                    <input type="hidden" />
                                </Form.Item>
                                <Form.Item name={[record.name, "MonedaDR"]} noStyle>
                                    <input type="hidden" />
                                </Form.Item>
                                <Typography.Text style={{ display: "block" }}>
                                    <strong>UUID:</strong> {idDocumento}
                                </Typography.Text>
                                <Typography.Text style={{ display: "block" }}>
                                    <strong>Serie:</strong> {serie}
                                </Typography.Text>
                                <Typography.Text style={{ display: "block" }}>
                                    <strong>Folio:</strong> {folio}
                                </Typography.Text>
                                <Typography.Text style={{ display: "block" }}>
                                    <strong>Moneda:</strong> {monedaDR}
                                </Typography.Text>
                            </>
                        );
                    }}
                </Form.Item>
            ),
        },
        {
            title: "Metodo De Pago DR",
            key: "MetodoDePagoDR",
            width: 120,
            render: (_, record) => (
                <Form.Item name={[record.name, "MetodoDePagoDR"]} noStyle>
                    <Select size="small" style={{ width: "100%" }} optionLabelProp="value">
                        <Option value="PUE">
                            <strong>PUE</strong> - Pago en Una sola Exhibición
                        </Option>
                        <Option value="PPD">
                            <strong>PPD</strong> - Pago en Parcialidades o Diferido
                        </Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: "NumParcialidad",
            key: "NumParcialidad",
            width: 120,
            render: (_, record) => (
                <Form.Item name={[record.name, "NumParcialidad"]} noStyle>
                    <Input bordered={false} />
                </Form.Item>
            ),
        },
        {
            title: "ImpSaldoAnt",
            key: "ImpSaldoAnt",
            width: 110,
            render: (_, record) => (
                <Form.Item name={[record.name, "ImpSaldoAnt"]} noStyle>
                    <InputNumber
                        style={{ textAlign: "end", width: "100%" }}
                        controls={false}
                        formatter={(value) => {
                            if (!value) return "";
                            const parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return `$ ${parts.join(".")}`;
                        }}
                        parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                        bordered={false}
                    />
                </Form.Item>
            ),
        },
        {
            title: "ImpPagado",
            key: "ImpPagado",
            width: 100,
            render: (_, record) => (
                <Form.Item name={[record.name, "ImpPagado"]} noStyle>
                    <InputNumber
                        style={{ textAlign: "end", width: "100%" }}
                        controls={false}
                        formatter={(value) => {
                            if (!value) return "";
                            const parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return `$ ${parts.join(".")}`;
                        }}
                        parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                        bordered={false}
                    />
                </Form.Item>
            ),
        },
        {
            title: "ImpSaldoInsoluto",
            key: "ImpSaldoInsoluto",
            width: 130,
            render: (_, record) => (
                <Form.Item name={[record.name, "ImpSaldoInsoluto"]} noStyle>
                    <InputNumber
                        style={{ textAlign: "end", width: "100%" }}
                        controls={false}
                        formatter={(value) => {
                            if (!value) return "";
                            const parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return `$ ${parts.join(".")}`;
                        }}
                        parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                        bordered={false}
                    />
                </Form.Item>
            ),
        },
        {
            title: "ObjetoImpDR",
            key: "ObjetoImpDR",
            width: 100,
            render: (_, record) => (
                <Form.Item name={[record.name, "ObjetoImpDR"]} noStyle>
                    <Select 
                        size="small" 
                        style={{ width: "100%" }} 
                        optionLabelProp="value"
                        onChange={(value) => {
                            if (value === "01" || value === "02") {
                    
                                calcularImpuestosPComplementoPago(form);
                            }
                        }}
                    >
                        <Option value="01">
                            <strong>01</strong> - No objeto de impuesto
                        </Option>
                        <Option value="02">
                            <strong>02</strong> - Sí objeto de impuesto
                        </Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: "EquivalenciaDR",
            key: "EquivalenciaDR",
            width: 110,
            render: (_, record) => (
                <Form.Item name={[record.name, "EquivalenciaDR"]} noStyle>
                    <Input bordered={false} />
                </Form.Item>
            ),
        },
        {
            title: "ImpuestosDR",
            key: "ImpuestosDR",
            width: 250,
            render: (_, record) => (
                <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                        const basePath = ["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "DoctoRelacionado", record.name];
                        const objetoImpDR = getFieldValue([...basePath, "ObjetoImpDR"]);
                        const isDisabled = objetoImpDR === "01";

                        return (
                            <div style={{ padding: "4px" }}>
                                <Typography.Text strong style={{ fontSize: "11px", display: "block", marginBottom: 4 }}>TrasladosDR</Typography.Text>
                                <div style={{ 
                                    border: "1px solid #d9d9d9", 
                                    padding: "4px 8px", 
                                    borderRadius: 4,
                                    display: "grid",
                                    gridTemplateColumns: "90px 1fr",
                                    gap: "4px 8px",
                                    alignItems: "center",
                                    fontSize: "12px"
                                }}>
                                    <Typography.Text style={{ fontSize: "11px" }}>BaseDR:</Typography.Text>
                                    <Form.Item name={[record.name, "ImpuestosDR", "TrasladosDR", 0, "BaseDR"]} noStyle>
                                        <InputNumber
                                            size="small"
                                            disabled={isDisabled}
                                            style={{ width: "100%" }}
                                            controls={false}
                                            formatter={(value) => {
                                                if (!value) return "";
                                                const parts = value.toString().split(".");
                                                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                return `$ ${parts.join(".")}`;
                                            }}
                                            parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                                            onChange={(value) => {
                                                if (!isDisabled && value) {
                                                    handleOnChangeBaseDR(value, record);
                                                }
                                            }}
                                        />
                                    </Form.Item>

                                    <Typography.Text style={{ fontSize: "11px" }}>ImpuestoDR:</Typography.Text>
                                    <Form.Item name={[record.name, "ImpuestosDR", "TrasladosDR", 0, "ImpuestoDR"]} noStyle>
                                        <Select size="small" disabled={isDisabled} style={{ width: "100%" }}>
                                            <Option value="002">002 - IVA</Option>
                                            <Option value="003">003 - IEPS</Option>
                                        </Select>
                                    </Form.Item>

                                    <Typography.Text style={{ fontSize: "11px" }}>TipoFactorDR:</Typography.Text>
                                    <Form.Item name={[record.name, "ImpuestosDR", "TrasladosDR", 0, "TipoFactorDR"]} noStyle>
                                        <Select size="small" disabled={isDisabled} style={{ width: "100%" }}>
                                            <Option value="Tasa">Tasa</Option>
                                            <Option value="Cuota">Cuota</Option>
                                            <Option value="Exento">Exento</Option>
                                        </Select>
                                    </Form.Item>

                                    <Typography.Text style={{ fontSize: "11px" }}>TasaOCuotaDR:</Typography.Text>
                                    <Form.Item name={[record.name, "ImpuestosDR", "TrasladosDR", 0, "TasaOCuotaDR"]} noStyle>
                                        <Input 
                                            size="small" 
                                            disabled={isDisabled} 
                                            style={{ width: "100%" }}
                                            onChange={(e) => {
                                                if (!isDisabled) {
                                                    handleOnChangeTasaOCuotaDR(e.target.value, record);
                                                }
                                            }}
                                        />
                                    </Form.Item>

                                    <Typography.Text style={{ fontSize: "11px" }}>ImporteDR:</Typography.Text>
                                    <Form.Item name={[record.name, "ImpuestosDR", "TrasladosDR", 0, "ImporteDR"]} noStyle>
                                        <InputNumber
                                            size="small"
                                            disabled={isDisabled}
                                            style={{ width: "100%" }}
                                            controls={false}
                                            formatter={(value) => {
                                                if (!value) return "";
                                                const parts = value.toString().split(".");
                                                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                return `$ ${parts.join(".")}`;
                                            }}
                                            parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        );
                    }}
                </Form.Item>
            ),
        },
    ];

    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5}>Complementos de Pago</Title>
            </Row>

            <Table
                size="small"
                bordered
                pagination={false}
                scroll={{ x: 1000 }}
                rowKey="key"
                columns={pagoColumns}
                dataSource={[{ key: "pago-0" }]}
            />

            <Row>
                <Title level={5} style={{ marginTop: 8 }}>DoctoRelacionado</Title>
            </Row>

            <Form.List name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "DoctoRelacionado"]}>
                {(fields, { add, remove }) => (
                    <>
                        <Table
                            className="table-products"
                            size="small"
                            bordered
                            pagination={false}
                            scroll={{ x: 2600 }}
                            rowKey="key"
                            columns={doctoColumns(remove)}
                            dataSource={fields}
                        />
                    </>
                )}
            </Form.List>

            <TotalesComplementoPagoSection />

            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
            </Row>
        </>
    );
};

export default ComplementosPagoSection;
